import Icon from '../components/Icon.vue'

Icon.register({
  'envelope-open-text': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M176 216H336C344.8 216 352 208.8 352 200V184C352 175.2 344.8 168 336 168H176C167.2 168 160 175.2 160 184V200C160 208.8 167.2 216 176 216zM160 296C160 304.8 167.2 312 176 312H336C344.8 312 352 304.8 352 296V280C352 271.2 344.8 264 336 264H176C167.2 264 160 271.2 160 280V296zM256 417.1C239.6 417.1 223.2 412.1 209.1 401.9L0 250.9V464C0 490.5 21.5 512 48 512H464C490.5 512 512 490.5 512 464V250.9L302.9 401.9C288.8 412.1 272.4 417.1 256 417.1zM493.6 162.9C484.8 156 476.4 149.5 464 140.1V96C464 69.5 442.5 48 416 48H338.4C335.4 45.8 332.6 43.7 329.4 41.4 312.6 29.2 279.2-0.4 256 0 232.8-0.4 199.4 29.2 182.6 41.4 179.4 43.7 176.6 45.8 173.6 48H96C69.5 48 48 69.5 48 96V140.1C35.6 149.5 27.2 156 18.4 162.9A48-48 0 0 1 0 200.7V211.4L96 280.7V96H416V280.7L512 211.4V200.7C512 186 505.2 172.1 493.6 162.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/envelope-open-text.js
// module id = ubXo
// module chunks = 144